class OrderNote extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.textArea = this.querySelector('textarea[name="note"]');
        this.loadOrderNote();

        this.textArea.addEventListener('input', this.debounce(() => {
            if (this.textArea.value.trim()) {
                this.updateOrderNote();
            }
        }, 500));
    }

    loadOrderNote() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                if (cart.note) {
                    this.textArea.value = cart.note;
                }
            });
    }

    updateOrderNote() {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                note: this.textArea.value.trim()
            })
        })
        .then(response => response.json())
        .then(cart => {
            console.log('Order note updated:', cart.note);
        })
        .catch(error => {
            console.error('Error updating order note:', error);
        });
    }

    debounce(func, delay) {
        let timeout;
        return function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    }
}

customElements.define('order-note', OrderNote);
